export default __webpack_public_path__ + "static/media/data_science.9dcadb15.svg";